import prescriptionsImage from '@/assets/images/help/getting-started/prescriptions.png';
import signup1Image from '@/assets/images/help/getting-started/signup-1.png';
import signup2Image from '@/assets/images/help/getting-started/signup-2.png';
import type { HelpFaqProps } from '@/components/help/HelpFaq';
import { HelpFaq } from '@/components/help/HelpFaq';

const helpFaqData: HelpFaqProps = {
  title: 'Getting Started',
  subtitle: 'Intro to EternaLife',
  faq: [
    {
      question: 'What is EternaLife?',
      answer: (
        <>
          <h3>Who we are</h3>
          <p>
            EternaLife is a pioneering force at the forefront of the longevity
            supplement industry. As the name implies, we are devoted to helping
            individuals live their fullest, healthiest lives, by facilitating
            their journey toward enhanced longevity.
          </p>
          <p>
            Our commitment lies in providing superior quality products that are
            designed with meticulous attention to detail. Each ingredient we
            incorporate is chosen for its exceptional bioavailability and the
            remarkable synergies they create, working collectively to tackle
            aging at the cellular level. From the selection of our raw materials
            to the finished product, every step is guided by an unwavering
            dedication to purity, ensuring that our formulations are free from
            sugars, lactose, gluten, and any unnecessary additives.
          </p>
          <h3>What we do</h3>
          <p>
            At EternaLife, we provide more than just premium supplements; we
            offer a truly personalized approach to wellness. We deliver our
            supplements pre-sorted into packets according to the time of day,
            providing you with the utmost convenience and ensuring you receive
            optimal benefits from each formula. But that's not all. To ensure
            your regimen is uniquely tailored to your needs, we collaborate with
            your doctor to incorporate insights gained from your blood, DNA, and
            epigenetic results. Our team of pharmacists also reviews your
            condition and potential medication interactions, helping us design a
            supplementation protocol that truly resonates with your individual
            health profile.
          </p>
          <p>
            The manufacturing process occurs in a Good Manufacturing Practice
            (GMP) facility, ensuring the highest quality standards. As a
            testament to our commitment to transparency, we provide
            comprehensive details about all active compounds, complete with
            third-party testing reports. Our mission is to optimize your
            supplement absorption, bringing you closer to a healthier, longer
            life, one day at a time.
          </p>
        </>
      ),
    },
    {
      question: 'How to sign up?',
      answer: (
        <>
          <p>
            To get started with EternaLife, you sign up online. If you have all
            your information on hand, signing up should only take about{' '}
            <strong>3-5 minutes</strong>. Here's some info you might want to
            gather before you get started:
          </p>
          <div className="my-8 flex flex-col gap-4 md:flex-row">
            <img
              src={signup1Image}
              alt="Signup step 1"
              className="my-0! w-[300px]"
            />
            <img
              src={signup2Image}
              alt="Signup step 2"
              className="my-0! w-[300px]"
            />
          </div>
          <p>
            Once your application has been submitted, our dedicated team will
            review it. This process, which ensures the highest level of
            personalization and care, may require up to three days as we
            coordinate with your healthcare clinic and obtain a thorough
            recommendation from your physician.
          </p>
          <p>
            Upon approval, you will discover a tailored supplement subscription
            curated specifically for you, reflecting the considered
            recommendations of your doctor.
          </p>
          <p>
            <em>Supplement subscription example:</em>
          </p>
          <div className="my-4">
            <img
              src={prescriptionsImage}
              alt="Supplement subscription example"
              className="w-[300px]"
            />
          </div>
          <h3>When to sign up</h3>
          <p>
            You can only access the EternaLife service upon receiving a
            recommendation or direction of your healthcare specialist or
            treatment facility, who will provide us with your health and genetic
            data and recommend longevity supplements tailored to your individual
            needs after examining your blood work, DNA or epigenetics.
          </p>
        </>
      ),
    },
  ],
};

export const GettingStartedPage = () => {
  return <HelpFaq {...helpFaqData} />;
};
